import React, { useState, useEffect } from 'react';
import ApiManager from '../../ApiManager/ApiManager';
import { useComponentLoading } from '../../utils/useComponentLoading';
import './TripStatistics.css';

const TripStatistics = () => {
  const [statistics, setStatistics] = useState({
    ongoingTripsCount: 0,
    activeDriversCount: 0,
    averageSpeed: 0,
    delayPercentage: 0,
    completedToday: 0
  });

  const { isLoading, withLoading } = useComponentLoading({
    fetchStatistics: false
  });

  const fetchTripStatistics = async () => {
    try {
      await withLoading('fetchStatistics', async () => {
        const response = await ApiManager.getTripStatistics();
        if (!response.ok) throw new Error('Failed to fetch trip statistics');
        const data = await response.json();
        setStatistics(data);
      }, 'Loading statistics...');
    } catch (error) {
      console.error('Error fetching trip statistics:', error);
      // Keep default values on error
    }
  };

  useEffect(() => {
    fetchTripStatistics();
    
    // Refresh statistics every 30 seconds
    const interval = setInterval(fetchTripStatistics, 30000);
    return () => clearInterval(interval);
  }, []);

  const statisticsCards = [
    {
      title: 'Ongoing Trips',
      value: statistics.ongoingTripsCount,
      icon: '🚗',
      color: '#4CAF50',
      bgColor: 'rgba(76, 175, 80, 0.1)'
    },
    {
      title: 'Active Drivers',
      value: statistics.activeDriversCount,
      icon: '👨‍💼',
      color: '#2196F3',
      bgColor: 'rgba(33, 150, 243, 0.1)'
    },
    {
      title: 'Average Speed',
      value: `${statistics.averageSpeed?.toFixed(1)} km/h`,
      icon: '⚡',
      color: '#FF9800',
      bgColor: 'rgba(255, 152, 0, 0.1)'
    },
    {
      title: 'Delay Percentage',
      value: `${statistics.delayPercentage?.toFixed(1)}%`,
      icon: '⏰',
      color: statistics.delayPercentage > 20 ? '#F44336' : '#4CAF50',
      bgColor: statistics.delayPercentage > 20 ? 'rgba(244, 67, 54, 0.1)' : 'rgba(76, 175, 80, 0.1)'
    },
    {
      title: 'Completed Today',
      value: statistics.completedToday,
      icon: '✅',
      color: '#9C27B0',
      bgColor: 'rgba(156, 39, 176, 0.1)'
    }
  ];

  if (isLoading('fetchStatistics')) {
    return (
      <div className="trip-statistics loading">
        <div className="statistics-skeleton">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="stat-card skeleton">
              <div className="skeleton-content">
                <div className="skeleton-icon"></div>
                <div className="skeleton-text">
                  <div className="skeleton-line title"></div>
                  <div className="skeleton-line value"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="trip-statistics">
      <div className="statistics-grid">
        {statisticsCards.map((card, index) => (
          <div
            key={index}
            className="stat-card"
            style={{
              backgroundColor: card.bgColor,
              borderColor: card.color
            }}
          >
            <div className="stat-icon" style={{ color: card.color }}>
              {card.icon}
            </div>
            <div className="stat-content">
              <div className="stat-title">{card.title}</div>
              <div className="stat-value" style={{ color: card.color }}>
                {card.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripStatistics; 